'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.putAppSettings = exports.putGlobalSettings = exports.getSettings = undefined;

var _cimpressCustomizr = require('cimpress-customizr');

var _languages = require('./utils/languages');

var _languages2 = require('./constants/languages');

var settingsCache = {};
var EMPTY_LIST = [];

var getSettings = exports.getSettings = function getSettings(authToken) {
  var supportedLanguages = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _languages2.languageCodes;

  if (settingsCache.global) {
    return Promise.resolve(settingsCache);
  }

  return (0, _cimpressCustomizr.getMcpSettings)(authToken).then(function (globalSettings) {
    // NOTE: globalSettings.language is the array of preferred languages
    var language = (0, _languages.getFirstSupportedLanguage)(globalSettings.language || EMPTY_LIST, supportedLanguages);
    settingsCache.global = {
      language: language,
      regionalSettings: globalSettings.regionalSettings,
      timezone: globalSettings.timezone
    };
    return settingsCache;
  }).catch(function (err) {
    console.warn(err);
    return settingsCache;
  });
};

var putGlobalSettings = exports.putGlobalSettings = function putGlobalSettings(authToken, language, regionalSettings, timezone) {
  return (0, _cimpressCustomizr.setPreferredMcpSettings)(authToken, language, regionalSettings, timezone).then(function (newData) {
    settingsCache.global = {
      // NOTE: newData.language is the array of preferred languages
      language: newData.language[0],
      regionalSettings: newData.regionalSettings,
      timezone: newData.timezone
    };
  });
};

var putAppSettings = exports.putAppSettings = function putAppSettings(authToken, appSettings) {
  settingsCache.app = appSettings;
};